import { b as getTrustPilotInfo } from "../../../../chunks/utils.js";
const load = async () => {
  const trustPilotInfo = await getTrustPilotInfo();
  return {
    trustPilotInfo
  };
};
export {
  load
};
